module.exports = __webpack_public_path__ + "img/background_c4-1_mobile.5c4d2f11.png";